// Global cache shared across all packs
if (!window.__ncinoComponentsPromise) {
  window.__ncinoComponentsPromise = null
}

export function ensureNcinoWebComponents () {
  // Prevent multiple simultaneous imports across all packs
  if (window.__ncinoComponentsPromise) {
    return window.__ncinoComponentsPromise
  }

  window.__ncinoComponentsPromise = import('@ncino/web-components/dist/index.gator.js')
  return window.__ncinoComponentsPromise
}
